<template>
    <div>
        <v-toolbar class="elevation-1">
            <v-toolbar-title>{{ title }}</v-toolbar-title>

            <div class="flex-grow-1"></div>

            <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn color="primary" class="ma-0" min-width="0" @click="submit">
                    <v-icon>check</v-icon>
                </v-btn>
            </template>
        </v-toolbar>

        <v-form autocomplete="off"
                ref="form"
                v-model="valid"
        >
            <!-- Developer and date form -->
            <FormCard>
                <template v-slot:form>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <v-text-field
                                    class="custom_textfield"
                                    v-model="item.invoice_number_gr"
                                    :label="$t('general.invoice_number_gr')"
                                    type="number"
                                    min="0"
                                    outlined
                                    :rules="field_required_rule"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <v-text-field
                                    class="custom_textfield"
                                    v-model="item.invoice_number_cy"
                                    :label="$t('general.invoice_number_cy')"
                                    type="number"
                                    min="0"
                                    outlined
                                    :rules="field_required_rule"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </FormCard>
        </v-form>
    </div>
</template>

<script>
    import FormCard from '../components/FormCard.vue'

    export default {
        components: {
            FormCard
        },
        props: {
            title: {type: String}
        },
        data() {
            return {
                url: '/api/app-settings',
                item: {
                    invoice_number_gr: null,
                    invoice_number_cy: null
                },

                // Validation
                valid: true,
                field_required_rule: [
                    v => !!v || `${this.$t('validation.required')}`
                ]
            }
        },
        async mounted() {
            await this.getData();
        },
        methods: {
            // get settings data
            async getData() {
                let response = await this.$store.dispatch('fetchData', {
                    url: this.url,
                });

                for (let prop in this.item) {
                    this.item[prop] = response.data[prop];
                }
            },
            // save settings
            async submit() {
                // Validate data
                if (this.$refs.form.validate()) {
                    await this.$store.dispatch('sendData', {
                        method: 'post',
                        url: this.url,
                        data: this.item
                    });
                }
            }
        }
    }
</script>